import React from 'react';
import '../../../assets/css/style.css';
import RadioChipContainer from '../elements/RadioChipContainer';

const VirtuesDrink = () => {
    const intakeNames = ['Socially','Regularly','Never','Prefer Not to Say'];

    return (
        <div className="chip-container">
            <RadioChipContainer labels={intakeNames} type="drinking" />
        </div>
    );
};

export default VirtuesDrink;